<button
    class="create-entity-btn"
    type="button"
    [disabled]="disabled()"
    [matTooltip]="disabled() && tooltipKey() ? (tooltipKey() | transloco) : ''"
    [matTooltipDisabled]="!disabled() || !tooltipKey()"
    (click)="onClick($event)">
    <fa-icon
        size="lg"
        [icon]="['fas', 'add']" />
</button>
